import moment from 'moment';

 /**@method getFullAge
 * @param {str} "2017/3/13" birthDay
 * @param {date} "2017/3/13"|| Date  beginDate
 * @return {Number} 年龄
 * 计算两个日期之间相差的周岁
 * 根据，周岁＝今年-出生年（已过生日）（未过生日还要-1）
 **/
export function getFullAge(birthDay, strDate=new Date()) {
    if (!birthDay || !strDate) return 0;
    var d1 = new Date(birthDay);
    var d2 = strDate || new Date(strDate.replace(/-/g, "/"))
    if (d1 == "Invalid Date" || d2 == "Invalid Date") {
        throw new Error("birthDay format error");
    }
    var age = Math.abs(d1.getFullYear() - d2.getFullYear());
    var day1 = moment(d1).get("month")+""+ moment(d1).get("date") //生日的月和天
    var day2 = moment(d2).get("month")+""+ moment(d2).get("date")
  
    if (Number(day1) > Number(day2)) { //表示未过生日，减掉1岁
        age = age - 1;
    }
    return age;
  }
export default function getIdCardInfo(id) {
    //15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日期，第15位代表性别，奇数为男，偶数为女。
    //18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
    var idCardInfo = {y:0,m:0,sex:""};
    idCardInfo.id = id;
    var y = 0,
        m = 0,
        d = 0,
        sex = '';
    if (id.length == 15) {
        y = id.substring(6, 8);
        m = id.substring(8, 10);
        d = id.substring(10, 12);
        sex = id.substring(14, 15);
        sex = sex % 2 == 1 ? 'M' : 'F';
        if (y > 10) y = '19' + y;
        else y = '20' + y;
    } else if (id.length == 18) {
        y = id.substring(6, 10);
        m = id.substring(10, 12);
        d = id.substring(12, 14);
        sex = id.substring(16, 17);
        sex = sex % 2 == 1 ? 'M' : 'F';
    } else {
        idCardInfo.error = true;
    }
    idCardInfo.year = y;
    idCardInfo.month = m;
    idCardInfo.day = d;
    idCardInfo.sex = sex;
    idCardInfo.birthDay = y + '-' + m + '-' + d;
    return idCardInfo;
}